
import Api from "../services/Api";


export const updtUser = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/user/manage/update', userData);

      console.log('response.results', response);
      res.status = "valid";

      res = {...res,...response};

      // console.log(res);

      return res;

    } catch (error) {

      console.log(error);
      res.status = "error";
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};